import Theme from '@adsk/alloy-react-theme';

export const radioLabelStyles = {
  display: 'flex',
  alignItems: 'center',
  paddingTop: '20px',
};

export const radioTextStyles = {
  ...Theme.typography.bodyMediumBold,
  paddingLeft: '10px',
};

export const accessDescriptionStyles = {
  paddingLeft: '26px',
};
